module.exports = __webpack_public_path__ + "static/media/underAnalysisIcon.0b561201.svg";